import { useMemo } from "react";
import { Navigate, useParams } from "react-router";
import { useLocale } from "use-intl";
import { NotFound, PageLoading } from "@/components/app/states";
import { useTraining } from "@/lib/queries";
import { toTrainingView } from "./model";
import { Trainer } from "./trainer";

export function TrainPage() {
  const { sessionId = "" } = useParams();
  const locale = useLocale();
  const training = useTraining(sessionId);
  const view = useMemo(() => (training.data ? toTrainingView(training.data, locale) : null), [training.data, locale]);
  if (training.isPending) return <PageLoading />;
  if (!view) return <NotFound />;
  if (view.session.finished) return <Navigate to={`/progress/session/${sessionId}`} replace />;
  if (view.logged.length === 0 && view.items.length === 0) return <Navigate to="/dashboard" replace />;
  return <Trainer key={sessionId} data={view} />;
}
